const COLORS = ["#F3D085", "#FFD700", "#C4B5FD", "#FBF7EE", "#E9B8FF", "#C59B27"];

let canvas = null;
let ctx = null;
let particles = [];
let rockets = [];
let rafId = null;
let lastTime = 0;

function reduced() {
    return document.documentElement.classList.contains("reduce-motion");
}

function ensureCanvas() {
    if (canvas && document.body.contains(canvas)) return;
    canvas = document.createElement("canvas");
    canvas.setAttribute("aria-hidden", "true");
    canvas.style.cssText = "position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:180;";
    document.body.appendChild(canvas);
    ctx = canvas.getContext("2d");
    resize();
    window.addEventListener("resize", resize);
}

function resize() {
    if (!canvas) return;
    canvas.width = window.innerWidth * Math.min(window.devicePixelRatio, 2);
    canvas.height = window.innerHeight * Math.min(window.devicePixelRatio, 2);
}

function loop(t) {
    const dt = Math.min((t - lastTime) / 16.7, 3);
    lastTime = t;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const scale = canvas.width / window.innerWidth;

    rockets = rockets.filter((r) => {
        r.y += r.vy * dt;
        r.vy += 0.08 * dt;
        ctx.beginPath();
        ctx.arc(r.x * scale, r.y * scale, 2.2 * scale, 0, Math.PI * 2);
        ctx.fillStyle = r.color;
        ctx.fill();
        if (r.vy >= -1.5) {
            spawnExplosion(r.x, r.y, 46, 3.4);
            return false;
        }
        return true;
    });

    particles = particles.filter((p) => {
        p.vy += p.gravity * dt;
        p.vx *= 0.985;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.rot += p.vrot * dt;
        p.life -= dt;
        if (p.life <= 0 || p.y > window.innerHeight + 40) return false;
        const alpha = Math.min(1, p.life / 30);
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x * scale, p.y * scale);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.shape === "rect") ctx.fillRect(-p.size * scale, -p.size * 0.6 * scale, p.size * 2 * scale, p.size * 1.2 * scale);
        else if (p.shape === "star") {
            ctx.beginPath();
            for (let i = 0; i < 4; i++) {
                ctx.rotate(Math.PI / 2);
                ctx.lineTo(0, -p.size * 1.6 * scale);
                ctx.lineTo(p.size * 0.32 * scale, -p.size * 0.32 * scale);
            }
            ctx.fill();
        } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.size * scale, 0, Math.PI * 2);
            ctx.fill();
        }
        ctx.restore();
        return true;
    });

    if (particles.length === 0 && rockets.length === 0) {
        rafId = null;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        return;
    }
    rafId = requestAnimationFrame(loop);
}

function kick() {
    ensureCanvas();
    if (!rafId) {
        lastTime = performance.now();
        rafId = requestAnimationFrame(loop);
    }
}

function spawnExplosion(x, y, count, power) {
    for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = (0.6 + Math.random()) * power;
        particles.push({
            x, y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed - 1,
            gravity: 0.06,
            life: 50 + Math.random() * 45,
            size: 1.4 + Math.random() * 2.2,
            rot: Math.random() * Math.PI,
            vrot: (Math.random() - 0.5) * 0.2,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            shape: "circle",
        });
    }
}

export function burst({ x = window.innerWidth / 2, y = window.innerHeight / 3, count = 90 } = {}) {
    if (reduced()) return;
    for (let i = 0; i < count; i++) {
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * 2.2;
        const speed = 4 + Math.random() * 9;
        particles.push({
            x, y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            gravity: 0.22,
            life: 70 + Math.random() * 60,
            size: 2.5 + Math.random() * 4,
            rot: Math.random() * Math.PI,
            vrot: (Math.random() - 0.5) * 0.3,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            shape: Math.random() > 0.6 ? "rect" : Math.random() > 0.5 ? "star" : "circle",
        });
    }
    kick();
}

export function fireworks(duration = 5000) {
    if (reduced()) return;
    ensureCanvas();
    const end = Date.now() + duration;
    const launch = () => {
        if (Date.now() > end) return;
        rockets.push({
            x: window.innerWidth * (0.15 + Math.random() * 0.7),
            y: window.innerHeight + 10,
            vy: -(9 + Math.random() * 4.5),
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
        });
        kick();
        setTimeout(launch, 260 + Math.random() * 320);
    };
    launch();
}
